module.exports = __webpack_public_path__ + "sprite/confetti-1.png";


//////////////////
// WEBPACK FOOTER
// ./sprite/confetti-1.png
// module id = 128
// module chunks = 3